import React from 'react';
import meJPEG from '../images/me.jpeg';

function About() {
  return (
    <div className="p-4 sm:mx-8 md:mx-10 h-full flex flex-col justify-center sm:text-lg xl:text-2xl lg:text-xl xl:flex-row xl:items-center">
      <div className="xl:px-4 md:mt-4">
        <h1 className="text-lightGreen font-bold text-2xl xl:text-4xl md:my-4 lg:text-3xl 2xl:mb-7">About Me</h1>
        <p className="text-slate-100 py-3 md:leading-8 lg:leading-6 xl:leading-9 2xl:leading-10">
          Hello! My name is <span className="text-lightGreen font-semibold">Joao Marco Matta</span>, I'm 28 years old and I live in São José dos Campos, São Paulo, Brazil.
        </p>
        <p className="text-slate-100 py-3 md:leading-8 lg:leading-6 xl:leading-9 2xl:leading-10">
          I'm a <span className="text-red-400 font-semibold">Fullstack Web Developer</span>, Game Designer and I'm currently studying <span className="text-lightGreen font-semibold">Blockchain Development</span>.
        </p>
        <p className="text-slate-100 py-3 md:leading-8 lg:leading-6 xl:leading-9 2xl:leading-10">
          I'm passionate about technology, programming, Web 3.0 and games.<span className="text-blue-100"> As I continue to improve my career and evolve as an individual, I'm always doing my best to contribute positively to the world and to people's success</span>.
        </p>
      </div>
      <img className="rounded-full w-2/4 sm:w-60 lg:w-64 xl:w-80 2xl:w-2/5 m-auto xl:my-0" src={ meJPEG } alt="A selfie of myself" />
    </div>
  );
}

export default About;
